<template>
	<div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="
				() => {
					showForm = !showForm
					generateServiceOrderReport(false)
				}
			"
			:title-form="$t('relatorioOrdemServico')"
			:backdrop="true"
		>
			<template #form>
				<div style="display: flex; flex-direction: column; gap: 1rem">
					<DropdownFk
						v-model="fazendaEscolhida"
						:dropdown-options="fazendas"
						:label="$t('pickFarm')"
					/>
					<DropdownFk
						v-model="ordemDeServicoEscolhida"
						:dropdown-options="ordensDeServico"
						:hidden-properties="[
							'orsv_dt_prazo_final',
							'orsv_dt_data_inicial',
							'orsv_dt_data_final',
						]"
						:label="$t('escolhaOrdemDeServico')"
					/>
					<div v-if="baixandoRelatorio">
						<Loading />
						<p style="text-align: center">
							{{ $t('baixandoRelatorio') }}
						</p>
					</div>

					<Button
						:disabled="ordemDeServicoEscolhida.length === 0"
						:label="$t('download')"
						@click="generateReport"
					/>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import CrudForm from '../../../components/CrudForm/CrudForm.vue'
import Button from '../../../components/Button/Button.vue'
import DropdownFk from '../../../components/DropdownFk/DropdownFk.vue'
import Loading from '../../../components/Loading/Loading.vue'

import { gerarRelatorioTrabalhoDoExecutorLegacy } from '../../../services/requests/RelatorioRequests'

import { mapMutations, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
// import axios from "axios";

import { GetReportDropdownOrdemServico } from '../../../services/requests/RelatorioRequests'

export default {
	name: 'RelatorioOrdemServicoPocket',
	components: {
		CrudForm,
		DropdownFk,
		Button,
		Loading,
	},
	data() {
		return {
			baixandoRelatorio: false,
			showForm: true,
			dropdown: [],
			fazendaEscolhida: '',
			ordemDeServicoEscolhida: '',
			dadosRelatorio: [],
			sourceCancelToken: null,
		}
	},
	computed: {
		...mapGetters('moduleImportShape', ['getGeoJsonPtio']),
		parcelasDaOrdemDeServico() {
			return this.dadosRelatorio.map((os) => os.numeroDeParcelas).reduce((a, b) => a + b, 0)
		},
		fazendas() {
			const fazendas = this.dropdown.map(({ fzda_nm_nome, fzda_cd_codigo, fk_fzda_fazenda }) => {
				return {
					nome: fzda_nm_nome,
					codigo: fzda_cd_codigo,
					id: fk_fzda_fazenda,
				}
			})
			return _.uniq(fazendas.map((fazenda) => fazenda.id)).map((id) => {
				const { nome, codigo } = fazendas.find((fazenda) => fazenda.id === id)
				return {
					id,
					[this.$t('name')]: nome,
					[this.$t('code')]: codigo,
				}
			})
		},
		ordensDeServico() {
			return this.dropdown
				.filter((ordem) => ordem.fk_fzda_fazenda === this.fazendaEscolhida)
				.map(
					({
						orsv_ds_descricao,
						orsv_cd_codigo,
						esfl_ds_descricao,
						id,
						orsv_tpsv_tipo_servico,
						orsv_dt_data_final,
						orsv_dt_data_inicial,
						orsv_dt_prazo_final,
					}) => {
						return {
							[this.$t('description')]: orsv_ds_descricao,
							[this.$t('code')]: orsv_cd_codigo,
							[this.$t('forestStratification')]: esfl_ds_descricao,
							[this.$t('serviceType')]: orsv_tpsv_tipo_servico,
							id,
							orsv_dt_prazo_final: new Date(orsv_dt_prazo_final).toLocaleDateString(),
							orsv_dt_data_inicial: new Date(orsv_dt_data_inicial).toLocaleDateString(),
							orsv_dt_data_final: new Date(orsv_dt_data_final).toLocaleDateString(),
						}
					},
				)
		},
		headers() {
			return [
				{
					key: 'codigo',
					value: 'Código',
					isActive: true,
				},
				{
					key: 'nome',
					value: 'Nome',
					isActive: true,
				},
				{
					key: 'funcao',
					value: 'Função',
					isActive: true,
				},
				{
					key: 'numeroDeParcelas',
					value: 'Parcelas',
					isActive: true,
				},
				{
					key: 'tempoNaOS',
					value: 'Tempo Total',
					isActive: true,
				},
				{
					key: 'mediaDeTempoEmCadaParcela',
					value: 'Tempo Médio por Parcela',
					isActive: true,
				},
			]
		},
	},
	created() {
		GetReportDropdownOrdemServico().then((response) => {
			this.dropdown = response.data.result
		})
	},
	methods: {
		...mapActions('moduleImportShape', ['setAllShapes']),
		...mapMutations('moduleReports', ['generateServiceOrderReport']),
		generateReport() {
			this.baixandoRelatorio = true
			gerarRelatorioTrabalhoDoExecutorLegacy(this.ordemDeServicoEscolhida)
				.then((result) => {
					var linkRelatorio = result.data.message
					this.downloadRelatorio(linkRelatorio)
					this.baixandoRelatorio = false
				})
				.catch((error) => {
					alert('Problema ao baixar o relatório, entre em contato com o suporte')
					this.baixandoRelatorio = false
					console.log(error)
				})
		},

		downloadRelatorio(link) {
			window.open(link, '_blank')
		},
	},
}
</script>
